<template>
    <v-row class="office365-settings ma-0 pa-0 mb-5" align="center">
        <v-col cols="6" class="pa-0 pe-3">
            <v-row class="ma-0" align="center">
                <v-text-field
                    :label="$t('User')"
                    v-model="officeAccount"
                    readonly
                    class="office-account-field"
                    :error-messages="emailOffice365Errors"
                ></v-text-field>
                <v-tooltip top v-if="isLogged">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon class="mx-2" color="primary" dark v-bind="attrs" v-on="on">mdi-check-circle-outline</v-icon>
                    </template>
                    <span>{{ $t('Site.Settings.Email.Logged') }}</span>
                </v-tooltip>
            </v-row>
        </v-col>
        <v-col class="">
        <v-btn small :color="isLogged ? 'gray' : 'primary'" class="px-5" @click="loginWithOffice365" :loading="loading">
            <v-icon small>mdi-account-key-outline</v-icon>
            <span class="mx-2">{{ isLogged ? $t('Site.Settings.Email.LogInOtherAccount') : $t('LoginToYourAccount') }}</span>
        </v-btn>
        </v-col>
    </v-row>
</template>
<script>
import AutoImportService from '@/services/AutoImportService';
import Office365Service from '@/services/Office365Service';

export default {
    name: 'EmailOffice365',
    props: {
        emailSettings: {
            type: Object,
            required: true
        },
        emailOffice365Errors: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            authToken: {}
        };
    },
    computed: {
        isLogged() {
            return this.emailSettings.office365RefreshToken && this.emailSettings.emailAccount;
        },
        officeAccount() {
            if (this.isLogged) {
                return this.emailSettings.emailAccount;
            }
            return '';
        },
    },
    methods: {
        async loginWithOffice365() {
            this.loading = true;
            const token = await this.performLogin();
            if (token) {
                this.emailSettings.office365RefreshToken = this.authToken.RefreshToken;
                const request = { RefreshToken: token.RefreshToken };
                const emailData = await Office365Service.getUserEmail(request);
                this.emailSettings.emailAccount = emailData.email;
            }
            this.loading = false;
        },
        async performLogin() {
            let token = null;
            const userID = this.$store.getters['account/user'].Id;
            let apiUrl = this.$store.getters['account/apiUrl'];
            const parameters = await AutoImportService.getOneDriveEndpointParameters();

            apiUrl = apiUrl.replace(/\/+$/, '');
            const office365LoginWindow = window.open(
                `${parameters.ApiURL}/authorize?client_id=${parameters.ClientID}&scope=offline_access%20user.read%20files.readwrite%20mail.send&response_type=code&state=${userID}&redirect_uri=${apiUrl}/api/auto-import/office365/set-token`,
                'resizable=yes,status=yes,location=yes'
            );

            token = await AutoImportService.getOffice365Token(userID);
            this.authToken = token;

            office365LoginWindow.close();
            return token;
        }
    },
};
</script>
<style>
.office-account-field {
    font-size: 14px;
    pointer-events: none;
    color: gray;
}
</style>
